import ImageListItem from '@mui/material/ImageListItem';
import ImageList from '@mui/material/ImageList';
import { IconComponent } from '@backstage/core-plugin-api';

import { ColumnBreakpoints, useDynamicColumns } from '../../hooks';
import { IconLink } from './IconLink';

export interface LinksGridListItem {
  href: string;
  text?: string;
  Icon?: IconComponent;
}

interface LinksGridListProps {
  items: LinksGridListItem[];
  cols?: ColumnBreakpoints | number;
}

export function LinksGridList(props: LinksGridListProps) {
  const { items, cols = undefined } = props;
  const numOfCols = useDynamicColumns(cols);

  return (
    <ImageList rowHeight="auto" cols={numOfCols}>
      {items.map(({ text, href, Icon }, i) => (
        <ImageListItem key={i}>
          <IconLink href={href} text={text ?? href} Icon={Icon} />
        </ImageListItem>
      ))}
    </ImageList>
  );
}
